import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { CaseDocument } from '../models/case-document';
import { DocumentCategory } from '../models/document-category';
import { Settings } from './settings';


@Injectable({
    providedIn: 'root'
})
export class CaseDocumentService {

    public URLPath: string = Settings.getInstance().BASE_URL + 'documents/casedocuments/';
    
    constructor(private http: HttpClient) { }

    getAllDocumentCategories(): Observable<any> {
    	return this.http.get<any>(Settings.getInstance().BASE_URL + 'documents/documentcategories')
            .pipe(
                retry(1)
            );
    }
    createDocumentCategory(record: DocumentCategory): Observable<any> {
        return this.http.post(Settings.getInstance().BASE_URL + 'documents/documentcategories', record)
            .pipe(
                retry(1)
            );
    }
    updateDocumentCategory(record: DocumentCategory): Observable<any> {
        return this.http.put(Settings.getInstance().BASE_URL + 'documents/documentcategories/'+ record.id, record)
            .pipe(
                retry(1) 
                
            );
    }
    deleteDocumentCategory(id: number): Observable<any> {
    	return this.http.delete<any>(Settings.getInstance().BASE_URL + 'documents/documentcategories/'+id)
                .pipe(
                    retry(1)
                );
    }
    /** Case Document Services **/
    getAllCaseDocument(): Observable<any> {
        return this.http.get<any>(this.URLPath)
            .pipe(
                retry(1)
            );
    }
    getAllCaseDocumentsForCase(caseId: number, showOlderDocs:boolean ): Observable<any> {

         return this.http.get<any>(this.URLPath + 'case/'+ caseId+'/'+ showOlderDocs)
        .pipe(
            retry(1)
        );
       
    }
    
    createCaseDocument(record: CaseDocument): Observable<any> {
        return this.http.post(this.URLPath, record)
            .pipe(
                retry(1)
            );
    }
    updateCaseDocument(record: CaseDocument): Observable<any> {
        return this.http.put(this.URLPath+ record.id, record)
            .pipe(
                retry(1) 
                
            );
    }
    deleteCaseDocument(id: number): Observable<any> {
        return this.http.delete(this.URLPath +  id)
            .pipe(
                retry(1)
            );
    }
    
    /* File upload.download methods */
    
    getCaseDocumentFile(caseDocumentId: any): Observable<any> {
		return this.http.get<any>(this.URLPath + 'file/' + caseDocumentId, { responseType: 'blob' as 'json' })
			.pipe(
				retry(0)
			);
	}
	
	removeCaseDocumentFile(caseDocumentId: number): Observable<any> {
		return this.http.delete(this.URLPath + 'file/' + caseDocumentId)
			.pipe(
				retry(1)
			);
	}
	uploadCaseDocumentFile(caseDocumentId: number, doc: File): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('casedocument', doc, doc.name);
		return this.http.post<any>(this.URLPath + 'file/upload/' + caseDocumentId, formData)
			.pipe(
				retry(0)
			);
	}
    
}
